import LogOutSvg from 'components/_common/Icons/SVGIcons/LogOutSvg';
import UserCircleSvg from 'components/_common/Icons/SVGIcons/UserCircleSvg';
import LazyImage from 'components/_common/LazyImage';
import { FFL_ROLE_SLUG } from 'config/app.config';
import { getFullName, getTruncatedString, placeParamsToURL } from 'helpers/CommonHelper';
import { notify } from 'helpers/NotifyHelper';
import { confirmAlert } from 'helpers/SwalAlertHelper';
import { t } from 'i18next';
import { useCallback, useMemo } from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { adminProfileMain } from 'routes/admin/AdminRoutes';
import { customerMainRoutes } from 'routes/customer/CustomerRoutes';
import { logoutUser } from 'store/auth/actions/AuthAction';
import {
  userCurrentRoleSelector,
  userProfileImageSelector,
  userProfileInfoSelector,
  userFFLInfoSelector,
} from 'store/auth/selectors/authSelectors';
import { useAppSelector } from 'store/hooks';

export default function ProfileDropdownMenu() {
  const userProfileInfo = useAppSelector(userProfileInfoSelector);
  const userFFLInfo = useAppSelector(userFFLInfoSelector);
  const userProfileImage = useAppSelector(userProfileImageSelector);
  const userRoleInfo = useAppSelector(userCurrentRoleSelector);
  const navigate = useNavigate();
  const confirmLogout = useCallback(async () => {
    // confirmation
    confirmAlert(
      t('confirm_title'),
      t('confirm_logout_msg'),
      async () => {
        const response = await logoutUser();
        if (response && response.status) {
          navigate(placeParamsToURL(customerMainRoutes.customerHome.path));
        } else {
          notify.error(response.message);
        }
      },
      { confirmBtnText: t('yes_confirm_logout_btn_text') }
    );
  }, [navigate]);
  const userInfo = useMemo(() => {
    const userObj = {
      name: '',
      title: '',
    };
    if (userProfileInfo && userRoleInfo) {
      userObj.name = getFullName(userProfileInfo.first_name, userProfileInfo.last_name);
      userObj.title =
        userRoleInfo?.slug === FFL_ROLE_SLUG
          ? userFFLInfo?.business_name || ''
          : userRoleInfo?.name || '';
    }
    return userObj;
  }, [userProfileInfo, userFFLInfo, userRoleInfo]);
  return (
    <Dropdown align="end">
      <Dropdown.Toggle as="div" className="profile-card" style={{ cursor: 'pointer' }}>
        <div className={`profile-card__avatar`}>
          <img src={userProfileImage} alt="Profile" className="profile-card__img" />
        </div>
        <div className="d-flex flex-column justify-content-center p-2">
          {userInfo.name && (
            <p className="profile-card__name" title={userInfo.name}>
              {getTruncatedString(userInfo.name, 20)}
            </p>
          )}
          {userInfo.title && (
            <p className="profile-card__title" title={userInfo.title}>
              {getTruncatedString(userInfo.title, 20)}
            </p>
          )}
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Card className="position-relative border-0">
          <Card.Body className="p-0">
            <div className="profile-dropdown-user-info d-flex flex-column align-items-center justify-content-center pt-2 pb-3">
              {userProfileImage && (
                <LazyImage
                  src={userProfileImage}
                  className="profile-dropdown-user-img"
                  width={40}
                />
              )}
              {userInfo.name && (
                <h6 className="text-black mb-0" title={userInfo.name}>
                  {getTruncatedString(userInfo.name, 30)}
                </h6>
              )}
              {userInfo.title ? <span title={userInfo.title}>{userInfo.title}</span> : ''}
            </div>
            <Dropdown.Item
              as={Link}
              to={placeParamsToURL(adminProfileMain.path)}
              className="profile-dropdown-item d-flex justify-content-start gap-2 text-start"
            >
              <UserCircleSvg />
              {t('profile')}
            </Dropdown.Item>
            <Dropdown.Item
              className="profile-dropdown-item d-flex justify-content-start gap-2 text-start"
              onClick={() => confirmLogout()}
            >
              <LogOutSvg />
              {t('logout')}
            </Dropdown.Item>
          </Card.Body>
        </Card>
      </Dropdown.Menu>
    </Dropdown>
  );
}
